module.exports = __webpack_public_path__ + "img/guide3.096986e7.png";